import instance from "./Instance/index.js";

export const getSkills = async (id) => {
  try {
    const response = await instance.get(`/skills/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getSkill = async (id) => {
  try {
    const response = await instance.get(`/skills/skill/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getHomeSkills = async (values) => {
  try {
    const response = await instance.post(`/skills/category`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getCategories = async () => {
  try {
    const response = await instance.get(`/skills/`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getSearch = async (values) => {
  try {
    const response = await instance.post(`/skills/search`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getTrainer = async (values) => {
  try {
    const response = await instance.post(`/skills/trainer`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const createSkill = async (values) => {
  try {
    const response = await instance.post(`/skills`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const deleteSkill = async (id) => {
  try {
    const response = await instance.delete(`/skills/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};
